import React from 'react';

const FlowContext = React.createContext();

export default FlowContext;
